import {
	colors,
	DynamicLink,
	Flex,
	Icon,
	IconTypes,
	Text,
} from "@capioweb/ui-components/src"
import styled from "styled-components"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"

interface CapioSocialMediaBlockProps {
	header: StringProperty
	instagramLink: StringProperty
	facebookLink: StringProperty
	linkedInLink: StringProperty
	instagramText: StringProperty
	facebookText: StringProperty
	linkedInText: StringProperty
}

interface SocialMediaIconProps {
	icon: string
}

const StyledIcon = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	height: 100%;
	background-color: ${colors.navy};
	transition: background-color 0.25s, height 0.2s ease;
	position: absolute;
	border-radius: 50%;

	:hover {
		background-color: ${colors.hoverBlue};
	}
	svg {
		width: 100%;
		height: 100%;
	}
`

const SocialMediaIcon = (props: SocialMediaIconProps) => {
	return (
		<Flex alignItems="center" w={6} h={6} position="relative">
			<StyledIcon>
				<Flex h={4.5} mx="auto">
					<Icon icon={props.icon as IconTypes} color="white"></Icon>
				</Flex>
			</StyledIcon>
		</Flex>
	)
}

const CapioSocialMediaBlock: React.FC<CapioSocialMediaBlockProps> = (props) => {
	return (
		<Flex
			as="section"
			px={3}
			pt={4.5}
			pb={5}
			my={{ _: 4, m: 8 }}
			backgroundColor="blue11"
			flexDirection="column"
			rowGap={{ _: 3, m: 3.5, l: 2 }}
		>
			<Text variant="headline-3" as="h2" mx="auto" mb={0} textAlign="center">
				{props.header?.value}
			</Text>
			<Flex columnGap={4} mx="auto">
				{props.linkedInLink?.value ? (
					<DynamicLink
						url={props.linkedInLink?.value}
						target="_blank"
						aria-label={props.linkedInText?.value}
					>
						<SocialMediaIcon icon={"linkedIn"} />
					</DynamicLink>
				) : (
					<Flex>
						<SocialMediaIcon icon={"linkedIn"} />
					</Flex>
				)}
				{props.facebookLink?.value ? (
					<DynamicLink
						url={props.facebookLink?.value}
						target="_blank"
						aria-label={props.facebookText?.value}
					>
						<SocialMediaIcon icon={"facebook2"} />
					</DynamicLink>
				) : (
					<Flex>
						<SocialMediaIcon icon={"facebook2"} />
					</Flex>
				)}

				{props.instagramLink?.value ? (
					<DynamicLink
						url={props.instagramLink?.value}
						target="_blank"
						aria-label={props.instagramText?.value}
					>
						<SocialMediaIcon icon={"instagram"} />
					</DynamicLink>
				) : (
					<Flex>
						<SocialMediaIcon icon={"instagram"} />
					</Flex>
				)}
			</Flex>
		</Flex>
	)
}

export { CapioSocialMediaBlock }
